import { vslApi } from '@/api';

export default Object.freeze({
  fetchMyContainerReleaseOrderList(params) {
    return vslApi.get(`/v1/public-ebookings/my-container-release-orders`, {
      params,
    });
  },
});
